import React from "react";
import { useLocation } from 'react-router-dom';
import logo from './zajednofront.png';
import back from './zajednoback.png';
import './Kartice.css';
import { useNavigate } from "react-router-dom"

export const Kartice = (props) => {
    const navigate = useNavigate();
    const location = useLocation();

    const handleSubmit = (e) => {
        e.preventDefault();
    }

    return (
        <div className="modern-form">
            <form className="kartice-form" onSubmit={handleSubmit}>
                <h1 className="form-title">Članska iskaznica</h1>
                
                {/* Front card */}
                <div className="card-container">
                    <img src={logo} className="card-image" alt="Card Front" />
                    <div className="card-overlay">
                        <div className="card-number">{location.state?.Ikartica || '105273'}</div>
                        <div className="card-name">{location.state?.Iime || 'Dubravko Demšer'}</div>
                    </div>
                </div>

                {/* Back card */}
                <div className="card-container">
                    <img src={back} className="card-image" alt="Card Back" />
                </div>

                {/* Contact information */}
                <div className="contact-info">
                    <h2>Adresa: Palmotićeva 50, 10000 Zagreb</h2>
                    <h2>sindikat@sindikat-zajedno.hr</h2>
                    <a 
                        href="https://www.sindikat-zajedno.hr/pogodnosti-za-clanove/" 
                        className="benefits-link"
                        target="_blank" 
                        rel="noopener noreferrer"
                    >
                        Korisničke pogodnosti
                    </a>
                </div>

                <button 
                    type="submit" 
                    className="btn" 
                    onClick={() => navigate('/')}
                >
                    Natrag
                </button>
            </form>
        </div>
    )
}
